"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVirtualized = require("react-virtualized");

var _excluded = ["list", "hasNextPage", "getNextPage", "fetching", "children", "noWindowScroller", "viewHeight"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InfiniteList = function InfiniteList(_ref) {
  var list = _ref.list,
      hasNextPage = _ref.hasNextPage,
      getNextPage = _ref.getNextPage,
      fetching = _ref.fetching,
      children = _ref.children,
      noWindowScroller = _ref.noWindowScroller,
      viewHeight = _ref.viewHeight,
      props = _objectWithoutProperties(_ref, _excluded);

  var length = list && list.length || 0;
  var rowCount = hasNextPage ? length + 1 : length + 0;

  var isRowLoaded = function isRowLoaded(_ref2) {
    var index = _ref2.index;
    return !hasNextPage || index < length;
  };

  var loadMoreRows = fetching ? function () {
    return null;
  } : getNextPage;

  if (noWindowScroller) {
    return /*#__PURE__*/_react.default.createElement(_reactVirtualized.InfiniteLoader, {
      rowCount: rowCount,
      loadMoreRows: loadMoreRows,
      isRowLoaded: isRowLoaded
    }, function (_ref3) {
      var onRowsRendered = _ref3.onRowsRendered,
          registerChild = _ref3.registerChild;
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
        disableHeight: true
      }, function (_ref4) {
        var width = _ref4.width;
        return _react.default.Children.map(children, function (child) {
          return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
            ref: registerChild,
            onRowsRendered: onRowsRendered,
            height: viewHeight || 500,
            width: width,
            rowCount: rowCount,
            list: list
          }, props));
        });
      });
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(_reactVirtualized.InfiniteLoader, {
      rowCount: rowCount,
      loadMoreRows: loadMoreRows,
      isRowLoaded: isRowLoaded
    }, function (_ref5) {
      var onRowsRendered = _ref5.onRowsRendered,
          registerChild = _ref5.registerChild;
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.WindowScroller, null, function (_ref6) {
        var height = _ref6.height,
            isScrolling = _ref6.isScrolling,
            scrollTop = _ref6.scrollTop;
        return /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
          disableHeight: true
        }, function (_ref7) {
          var width = _ref7.width;
          return _react.default.Children.map(children, function (child) {
            return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
              autoHeight: true,
              ref: registerChild,
              onRowsRendered: onRowsRendered,
              isScrolling: isScrolling,
              scrollTop: scrollTop,
              height: height,
              width: width,
              rowCount: rowCount,
              list: list
            }, props));
          });
        });
      });
    });
  }
};

InfiniteList.propTypes = {
  getNextPage: _propTypes.default.func.isRequired,
  children: _propTypes.default.any.isRequired,
  list: _propTypes.default.array,
  hasNextPage: _propTypes.default.bool,
  fetching: _propTypes.default.bool,
  noWindowScroller: _propTypes.default.bool,
  viewHeight: _propTypes.default.number
};
var _default = InfiniteList;
exports.default = _default;